module.exports = __webpack_public_path__ + "img/小荤.079d253f.png";